import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SampleNextArrow() {
  return <div />;
}

function SamplePrevArrow() {
  return <div />;
}

function TopSec() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    fade: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (_, next) => setCurrentSlide(next),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true } },
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1, initialSlide: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const slides = [
    { bg: "bgOne", key: 1 },
    { bg: "bgTwo", key: 2 },
    { bg: "bgThree", key: 3 },
    { bg: "bgFour", key: 4 },
  ];

  return (
    <div className="relative">
      <Slider {...settings}>
        {slides.map((slide) => (
          <div className={`${slide.bg} grid h-full place-items-center`} key={slide.key}>
            <div className="flex justify-center pt-10 mx-auto sm:pt-[120px] sm:w-[70%] px-10">
              <div className="overflow-hidden">
                <AnimatePresence mode="wait">
                  <motion.h1
                    key={currentSlide}
                    className="text-[32px] sm:text-[60px] text-[#FAFAFA] font-[900] text-center"
                    initial={{ opacity: 0, y: 30, filter: 'blur(8px)' }}
                    animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
                    exit={{ opacity: 0, y: -20, filter: 'blur(4px)' }}
                    transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
                  >
                    Welcome To Kelen Immigration Services
                  </motion.h1>
                </AnimatePresence>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      >
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FAFAFA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 5v14M5 12l7 7 7-7" />
        </svg>
      </motion.div>
    </div>
  );
}

export default TopSec;
